import { Injectable } from "@angular/core"
import { AngularFirestoreCollection } from "@angular/fire/firestore"
import { SingleTestersMetric, TesterMetric } from "@tr/models"
import { TrDatePipe } from "@tr/pipes"
import { CommonService } from "./common.service"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class SingleTestersMetricService extends FirebaseCollectionBase<SingleTestersMetric> {
  public getId = (item: SingleTestersMetric) => item._id
  constructor(
    fb: FirebaseService,
    private commonService: CommonService,
  ) {
    super(fb)
  }

  public getCollection(userId: string): AngularFirestoreCollection {
    return this.commonService.getSevaTesterResultsCollection(userId)
  }

  public async getSingleTesterMetricResults(dataItems: any[]): Promise<SingleTestersMetric[]> {
    const singleTesterMetrics: SingleTestersMetric[] = []
    dataItems.forEach(doc => {
      doc.results.forEach((result, i) => {
        singleTesterMetrics.push({
          _id: `${doc._id}-${i}`,
          ...result,
        } as SingleTestersMetric)
      })
    })
    return singleTesterMetrics
  }

  public async getSingleTesterMetric(uid: string, sevaTesterResults: any[]): Promise<TesterMetric> {
    const today = new Date()

    const user = await this.commonService.getUserByID(uid)

    const testerMetric: TesterMetric = {
      _id: uid,
      email: user.email,
      uid: user.uid,
      testsToday: 0,
      testsThisWeek: 0,
      testsPerDay: 0,
      stepsPerDay: 0,
      stepsToday: 0,
      stepsThisWeek: 0,
      blocked: 0,
      failed: 0,
      passed: 0,
      feedbackThisPeriod: 0,
      roles: user.roles,
    }

    return this.populateMetrics(sevaTesterResults, testerMetric, today)
  }

  public async populateMetrics(
    sevaTesterResults,
    testerMetric: TesterMetric,
    today: Date,
  ): Promise<TesterMetric> {
    const dayOfWeekToday = today.getDay()
    const firstDayOfWeek = today
    firstDayOfWeek.setHours(0, 0, 0, 0)
    firstDayOfWeek.setDate(today.getDate() - dayOfWeekToday)

    sevaTesterResults.forEach(resultItem => {
      if (resultItem.result === "Blocked") {
        testerMetric.blocked += 1
      } else if (resultItem.result === "Failed") {
        testerMetric.failed += 1
      } else if (resultItem.result === "Passed") {
        testerMetric.passed += 1
      }

      const date = TrDatePipe.toDate(resultItem.date)

      if (
        date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth()
      ) {
        if (date.getDate() === today.getDate()) {
          testerMetric.testsToday += 1
          if (resultItem.steps && resultItem.steps !== -1) {
            testerMetric.stepsToday += resultItem.steps
          }
        }
      }
      if (date >= firstDayOfWeek) {
        testerMetric.testsThisWeek += 1
        if (resultItem.steps && resultItem.steps !== -1) {
          testerMetric.stepsThisWeek += resultItem.steps
        }
      }
    })
    return testerMetric
  }
}
